import axios from 'axios';
import { IServicioTransferencia } from '@/shared/model/servicio-transferencia.model';

const baseApiUrl = 'api/servicio-transferencias';

export default class ServicioTransferenciaService {
  public find(): Promise<IServicioTransferencia> {
    return new Promise<IServicioTransferencia>((resolve, reject) => {
      axios.get(`${baseApiUrl}/1`).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }

  public update(entity: IServicioTransferencia): Promise<IServicioTransferencia> {
    return new Promise<IServicioTransferencia>((resolve, reject) => {
      axios.put(`${baseApiUrl}/1`, entity).then(res => resolve(res.data)).catch(err => reject(err));
    });
  }
}
